import { Text, View } from "react-native";
import { ResidentModel } from "../../../services/api/types/residents/models/ResidentModel";
import { UrgentConcernModel } from "../../../services/api/types/shiftHandover/models/UrgentConcernModel";
import { UrgentConcernTypeBadge } from "../../shiftHandover/atoms/UrgentConcernTypeBadge";
import { TaskItem } from "./TaskItem";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export interface Props {
  resident: ResidentModel;
  concern: UrgentConcernModel;
  onRowPress: (residentId: number) => void;
  handleMarkAsDone: (concern) => void;
  isConcernCompleted: boolean | undefined;
}

export function ConcernTaskItem({
  resident,
  concern,
  onRowPress,
  handleMarkAsDone,
  isConcernCompleted,
}: Props) {
  return (
    <TaskItem
      resident={resident}
      onRowPress={() => onRowPress(resident.id)}
      backgroundColourClass="bg-red-50"
      isCompleted={isConcernCompleted}
      handleMarkAsDone={() => handleMarkAsDone(concern)}
      permission={PermissionsEnums.UPDATE_SHIFT_HANDOVER}
      renderContent={() => (
        <View className="flex-col">
          <UrgentConcernTypeBadge type={concern.type} />
          <Text className="text-base">{`${concern?.description}`}</Text>
        </View>
      )}
    />
  );
}
